import { motion } from "framer-motion";

const partners = [
    {
        name: "DCC",
        monogram: "DCC",
        line: "Luxury vehicle specialists",
    },
    {
        name: "J7",
        monogram: "J7",
        line: "Security Services",
    },
    {
        name: "Jetimmobilier",
        monogram: "JM",
        line: "Aviation · Yachts · Villas",
    },
    {
        name: "JLC",
        monogram: "JLC",
        line: "By Appointment to His Majesty King Charles III\nService and repair of motor vehicles\nJLC Limited\nSevenoaks Kent",
    },
    {
        name: "Lawton Surgery",
        monogram: "LS",
        line: "Medical Partner",
    },
    {
        name: "The Red Carnation Hotel Collection",
        monogram: "RCH",
        line: "Hospitality Partner",
    },
    {
        name: "Stellsec Ltd",
        monogram: "ST",
        line: "Close Protection",
    },
    {
        name: "The Delivery Group",
        monogram: "TDG",
        line: "Domestic and International Specialist\nfor E-Commerce and Mail Distribution",
    },
];

export default function Partners() {
    return (
        <section
            id="partners"
            data-testid="partners-section"
            className="relative bg-surface py-24 md:py-40 overflow-hidden"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-8 mb-14 md:mb-20">
                    <div className="col-span-12 md:col-span-4">
                        <span className="font-sans text-[10px] uppercase tracking-[0.4em] text-oxblood">
                            № IV - In Confidence
                        </span>
                    </div>
                    <div className="col-span-12 md:col-span-8">
                        <motion.h2
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 1 }}
                            className="font-serif text-[2.2rem] md:text-[3rem] leading-[1.1]"
                        >
                            Trusted houses, quietly aligned.
                            <br />
                            <span className="italic text-oxblood">Our affiliate partners.</span>
                        </motion.h2>
                        <p className="mt-6 font-sans text-[14px] md:text-[15px] text-[#1A1A1A]/70 max-w-2xl leading-[1.85]">
                            A discreet network of operators with whom Monplaisir collaborates,
                            chosen for their standards and their silence.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-12 gap-x-6 gap-y-8 md:gap-y-10">
                    {partners.map((p, i) => (
                        <motion.div
                            key={p.name}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.8, delay: (i % 3) * 0.08 }}
                            data-testid={`partner-${p.monogram.toLowerCase()}`}
                            className="col-span-12 sm:col-span-6 lg:col-span-4 group"
                        >
                            <div className="flex items-center gap-6 border border-bone bg-cream px-6 py-7 md:px-8 md:py-9 h-full transition-all duration-500 group-hover:border-oxblood group-hover:bg-cream/80">
                                <div className="flex items-center justify-center w-[68px] h-[68px] md:w-[80px] md:h-[80px] border border-[#C5A880] text-[#5E1914] font-serif text-[16px] md:text-[18px] tracking-[0.08em] flex-shrink-0 transition-colors duration-500 group-hover:bg-[#5E1914] group-hover:text-[#E5C7A1]">
                                    {p.monogram}
                                </div>
                                <div className="min-w-0 flex-1">
                                    <div className="font-serif text-[18px] md:text-[20px] leading-tight tracking-tight">
                                        {p.name}
                                    </div>
                                    <div className="mt-2 font-sans text-[10px] md:text-[11px] uppercase tracking-[0.24em] text-[#595959] whitespace-pre-line leading-[1.7]">
                                        {p.line}
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
